module.exports = __webpack_public_path__ + "static/media/im.3e276e7d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/im.svg
// module id = 851
// module chunks = 0